module.exports = __webpack_public_path__ + "img/34.60f34c0e.jpg";